var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BasicFormFormat } from "../../src/View/UI/FormFormat/FormFormat";
import PipelineForm, { getPipelineSaveRequest, } from "../../src/View/Presentational/Pipeline/PipelineForm";
import PipelineService from "../../src/Services/Pipeline.service";
import useService from "../../src/View/Hooks/useService";
import ServiceResult from "../../src/View/UI/ServiceResult/ServiceResult";
import StageService from "../../src/Services/Stage.service";
import SecondaryNavButton, { SecondaryNavExternalLink, } from "../../src/View/UI/SecondaryNav/SecondaryNavButton";
import useConfirmation from "../../src/View/Hooks/useConfirmation";
import useErrorPopup from "../../src/View/Hooks/useErrorPopup";
import SecondaryNavLayout from "../../src/View/Layout/SecondaryNavLayout";
import PipelineStatusDomainService from "../../src/Domain/PipelineStatus/PipelineStatus.service";
import PipelineStatusBadge from "../../src/View/Presentational/PipelineStatus/PipelineStatusBadge";
import VirtualizedAppService from "../../src/Services/VirtualizedApp.service";
import { AlertInfo, AlertSuccess, } from "../../src/View/UI/StandardAlerts/StandardAlerts";
import { getPipelinesAdminListPath } from "./PipelinesAdmin";
import { getPipelineDetailPath } from "../../src/View/Pages/Pipeline/PipelineRoutes";
import PopulationService from "../../src/Services/Population.service";
const PipelinesEdit = () => {
    var _a, _b;
    const pipelineId = parseInt(useParams().pipelineId, 10);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [apps, loadApps] = useService(VirtualizedAppService.getAppsForCurrentUser);
    React.useEffect(() => {
        loadApps();
    }, [loadApps]);
    const [pipelineState, loadPipeline, { edit }] = useService((id) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const pipeline = yield PipelineService.get(id);
        let caseloadPeople = [];
        if ((_c = pipeline.population) === null || _c === void 0 ? void 0 : _c.adHoc) {
            caseloadPeople =
                yield PopulationService.getCaseloadsSelectionForFilterBackedPopulation(pipeline.population.id);
        }
        return { pipeline, caseloadPeople };
    }));
    const [stageOrder, setStageOrder] = React.useState([]);
    const resetStageOrder = (stages) => {
        setStageOrder(Array.from(Array(stages.length), (_, index) => index));
    };
    const orderedStages = React.useMemo(() => {
        if (!stageOrder) {
            return [];
        }
        return stageOrder
            .map((position) => {
            var _a, _b;
            return (_b = (_a = pipelineState.data) === null || _a === void 0 ? void 0 : _a.pipeline) === null || _b === void 0 ? void 0 : _b.stages[position];
        })
            .filter((stage) => stage != null);
    }, [(_b = (_a = pipelineState.data) === null || _a === void 0 ? void 0 : _a.pipeline) === null || _b === void 0 ? void 0 : _b.stages, stageOrder]);
    const editStages = React.useCallback((s) => {
        edit((resp) => {
            if (resp) {
                const p = resp.pipeline;
                const stages = typeof s === "function" ? s(p.stages) : s;
                resetStageOrder(stages);
                return {
                    pipeline: Object.assign(Object.assign({}, p), { stages }),
                    caseloadPeople: resp.caseloadPeople,
                };
            }
            throw new Error("No pipeline provided");
        });
    }, [edit]);
    const [stagesState, loadStages] = useService(StageService.search);
    const [archivePipelineState, archivePipeline] = useService(PipelineService.archive);
    const [showError, errorModals] = useErrorPopup();
    const [confirmation, confirmModals] = useConfirmation();
    const [activatePipelineState, activatePipeline] = useService(PipelineService.activatePipeline);
    const refreshPipeline = React.useCallback(() => {
        if (pipelineId) {
            loadPipeline(+pipelineId);
        }
    }, [loadPipeline, pipelineId]);
    React.useEffect(() => {
        refreshPipeline();
    }, [refreshPipeline]);
    const refreshStages = React.useCallback(() => {
        loadStages({ pipelineIds: [pipelineId] }).then((resp) => editStages(resp.data));
    }, [editStages, loadStages, pipelineId]);
    React.useEffect(() => {
        loadPipeline(pipelineId).then(({ pipeline }) => {
            resetStageOrder(pipeline.stages);
            refreshStages();
        });
    }, [loadPipeline, pipelineId, refreshStages]);
    const [canViewPipeline, updateCanViewPipeline] = useService(PipelineService.canCurrentUserViewPipeline);
    React.useEffect(() => {
        updateCanViewPipeline(pipelineId);
    }, [pipelineId, updateCanViewPipeline]);
    const submit = (state) => __awaiter(void 0, void 0, void 0, function* () {
        const editRequest = getPipelineSaveRequest(state);
        yield PipelineService.editPipelineWithStagesAndSchedule(editRequest).then((response) => {
            if (response) {
                setShowSuccessMessage(true);
                return Promise.resolve("Edit completed successfully.");
            }
            return Promise.reject("There was a problem saving this pipeline");
        });
    });
    // @ts-expect-error - TS7006 - Parameter 'pipeline' implicitly has an 'any' type.
    const navbarButtons = (pipeline) => {
        if (!pipeline) {
            return null;
        }
        return (_jsxs(_Fragment, { children: [pipeline.pipelineStatus.id ===
                    PipelineStatusDomainService.InactiveId && (_jsx(SecondaryNavButton, { icon: "play", label: "Activate", title: !(pipeline.pipelineStatus.id ===
                        PipelineStatusDomainService.InactiveId)
                        ? "Only inactive pipelines can be activated."
                        : "Activate this pipeline.", isLoading: activatePipelineState.isLoading, onClick: () => {
                        confirmation(_jsxs(_Fragment, { children: [_jsx(AlertInfo, { message: "When you activate a pipeline with a manual filter, all the people in the filter will become opportunities. If you have a scheduled filter, it will create the opportunities on the defined schedule." }), "Are you sure you want to activate this pipeline?"] })).then((confirmed) => {
                            if (confirmed) {
                                activatePipeline(pipeline.id)
                                    .catch((err) => showError("There was an error activating this pipeline", typeof err === "string" ? err : null))
                                    .then(() => {
                                    refreshPipeline();
                                });
                            }
                        });
                    } }, "activate")), pipeline.pipelineStatus.id ===
                    PipelineStatusDomainService.ActiveId && (_jsx(SecondaryNavButton, { icon: "archive", label: "Archive", title: !(pipeline.pipelineStatus.id ===
                        PipelineStatusDomainService.ActiveId)
                        ? "Only active pipelines can be archived"
                        : "Archive this pipeline.", isLoading: archivePipelineState.isLoading, onClick: () => {
                        confirmation("Are you sure you want to archive this pipeline? You will no longer be able to add or move opportunities in this pipeline.").then((confirmed) => {
                            if (confirmed) {
                                archivePipeline(pipeline.id)
                                    .catch((err) => showError("There was an error archiving this pipeline", typeof err === "string" ? err : null))
                                    .then(() => {
                                    refreshPipeline();
                                });
                            }
                        });
                    } }, "archive")), _jsx(SecondaryNavExternalLink, { icon: "glasses", title: 
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    apps.data.find((app) => app.name === pipeline.virtualizedApp.name) && canViewPipeline.data
                        ? "View this pipeline"
                        : "Unable to view this pipeline because you don't have access to the virtualized app it's in, or permission to view it.", label: "Open Pipeline", disabled: 
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    !apps.data.find((app) => app.name === pipeline.virtualizedApp.name) || !canViewPipeline.data, target: "_blank", href: getPipelineDetailPath(pipeline.id, pipeline.virtualizedApp.name) }, "glasses")] }));
    };
    const [shouldShowSaveButton, setShouldShowSaveButton] = React.useState(true);
    return (_jsxs(_Fragment, { children: [_jsx(ServiceResult, { state: pipelineState, children: ({ pipeline, caseloadPeople }) => {
                    var _a, _b, _c, _d, _e;
                    return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex", children: navbarButtons(pipeline) }), children: _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsxs("div", { className: "d-flex justify-content-between", children: [_jsxs("h1", { className: "title", children: [_jsx(Link, { to: getPipelinesAdminListPath(), className: "text-decoration-none", title: "Back to pipelines", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", "Edit ", pipeline.name] }), _jsx("div", { className: "h5", children: _jsx(PipelineStatusBadge, { pipelineStatus: pipeline.pipelineStatus }) })] }) }), _jsx("div", { role: "main", children: _jsxs(_Fragment, { children: [_jsx(BasicFormFormat, { handleSubmit: submit, hideButtons: !shouldShowSaveButton, defaultValue: {
                                                    pipeline: {
                                                        id: pipeline.id,
                                                        pipelineStatus: pipeline.pipelineStatus,
                                                        name: pipeline.name,
                                                        personType: pipeline.personType,
                                                        virtualizedApp: pipeline.virtualizedApp,
                                                        rolesThatCanView: (_a = pipeline.rolesThatCanView) !== null && _a !== void 0 ? _a : undefined,
                                                        rolesThatCanManageOpportunities: (_b = pipeline.rolesThatCanManageOpportunities) !== null && _b !== void 0 ? _b : undefined,
                                                    },
                                                    opportunity: {
                                                        population: (_c = pipeline.population) !== null && _c !== void 0 ? _c : undefined,
                                                        opportunitySource: (_d = pipeline.opportunitySource) !== null && _d !== void 0 ? _d : undefined,
                                                        automatedSchedule: {
                                                            schedule: (_e = pipeline.automatedSchedule) !== null && _e !== void 0 ? _e : undefined,
                                                            isManual: pipeline.automatedSchedule === null,
                                                        },
                                                        populationAdHocCaseloads: caseloadPeople,
                                                    },
                                                }, children: stageOrder && (_jsx(PipelineForm, { setShouldShowSaveButton: setShouldShowSaveButton, stageEditProps: {
                                                        // @ts-expect-error wip
                                                        stages: orderedStages,
                                                        refreshStages,
                                                        editStages,
                                                        stageOrder,
                                                        setStageOrder,
                                                        virtualizedAppName: pipeline.virtualizedApp.name,
                                                    } })) }), showSuccessMessage && (_jsx(AlertSuccess, { message: "Pipeline saved.", className: "mt-2" }))] }) })] }) }));
                } }), errorModals, confirmModals] }));
};
export default PipelinesEdit;
